class NativeResolver {
  constructor(content) {
    this.content = content
  }

  resolve() {
    try {
      const importJson = JSON.parse(this.content)
      if (
        importJson.version === '1.1' &&
        Object.prototype.hasOwnProperty.call(importJson, 'areas') &&
        Object.prototype.hasOwnProperty.call(importJson, 'projects') &&
        Object.prototype.hasOwnProperty.call(importJson, 'repeats') &&
        Object.prototype.hasOwnProperty.call(importJson, 'tags') &&
        Object.prototype.hasOwnProperty.call(importJson, 'todos')
      ) {
        return importJson
      }
    } catch (err) {
      return null
    }
  }
}

export default NativeResolver
